// Constants
var KEY_CODE_TAB = 9,
    KEY_CODE_BACKSPACE = 8;

/**
 * The module that will contain our validation directives. AngularJS provides $validators
 * to make custom validation easy.
 *
 * @type {*|module}
 */

// eslint-disable-next-line no-undef
var validationDirectives = angular.module("validationDirectives", []);

/**************** Directives for Registration Without Pin************************/

/***** Regex directive for international zipcode***********/

/**
 * Extends the AngularJS $validators to validate an input field for international zipcode
 *
 * Usage:
 * <input type="text" name="zipcode" data-ng-model="zipcode" reg-ex-input />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */

var regExInput = function () {
    "use strict";
    return {
        restrict: "A",
        require: "?regEx",
        scope: {},
        replace: false,
        link: function (scope, element, attrs, ctrl) {
            element.bind("keypress", function (event) {
                var regex = new RegExp(attrs.regEx);
                var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);

                // Allow TAB and BACKSPACE
                // keyCode should be used instead of charCode for non-printable keys
                if (event.keyCode === KEY_CODE_TAB || event.keyCode === KEY_CODE_BACKSPACE) {
                    return true;
                }

                if (!regex.test(key)) {
                    event.preventDefault();
                    return false;
                }
            });
        }
    };
};
validationDirectives.directive("regExInput", regExInput);

/***** SSN Length Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a nine-digit
 * Social Security Number with no punctuation.
 *
 * Usage:
 * <input type="text" name="ssn" data-ng-model="individual.ssn" data-ssn-length-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var ssnLengthValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^\d{9}$/;

            ctrl.$validators.ssnLength = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("ssnLengthValidator", ssnLengthValidator);

/***** SSN Digits Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for numeric value only.
 *
 * Usage:
 * <input type="text" name="ssn" data-ng-model="myModel.ssn" data-ssn-digits-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var ssnDigitsValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[0-9]*$/;

            ctrl.$validators.ssnDigits = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("ssnDigitsValidator", ssnDigitsValidator);

/***** Zipcode Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a five-digit
 * zipcode with no punctuation.
 *
 * Usage:
 * <input type="text" name="zipcode" data-ng-model="myModel.zipcode" data-zipcode-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var zipcodeLengthValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^\d{5}$/;

            ctrl.$validators.zipcodeLength = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("zipcodeLengthValidator", zipcodeLengthValidator);

/***** Zipcode Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a five-digit
 * zipcode with no punctuation.
 *
 * Usage:
 * <input type="text" name="zipcode" data-ng-model="myModel.zipcode" data-zipcode-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var zipcodeDigitsValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[0-9]*$/;

            ctrl.$validators.zipcodeDigits = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("zipcodeDigitsValidator", zipcodeDigitsValidator);

/***** Address Pattern Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for Address.
 *
 * Usage:
 * <input type="text" name="stline1" data-ng-model="myModel.stline1" data-address-pattern-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var addressPatternValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^(?=.*\d)[a-zA-Z0-9\-/#&; ]+$/;

            ctrl.$validators.addressPattern = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("addressPatternValidator", addressPatternValidator);

/***** Zipcode Pattern Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a five-digit
 * zipcode with no punctuation.
 *
 * Usage:
 * <input type="text" name="zipcode" data-ng-model="myModel.zipcode" data-zipcode-pattern-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var zipcodePatternValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /(^\d{5}$)|(^\d{5}-\d{4}$)|(^\d{5}-$)/;
            var stubPattern = /^\d{5}-$/;

            ctrl.$validators.zipcodePattern = function (value) {
                if (value === "") {
                    return true;
                }

                //special case for #####-  w/o trailing hyphen.
                if (stubPattern.test(value)) {
                    elem.val(value.substring(0, 5));
                }

                var rc = pattern.test(value);
                //console.log('zipcodePatternValidator',rc,'['+value+']',pattern.test(value),pattern);
                return rc;
            };
        }
    };
};
validationDirectives.directive("zipcodePatternValidator", zipcodePatternValidator);

/***** Zipcode Alpha Numeric Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a five-digit
 * zipcode with no punctuation.
 *
 * Usage:
 * <input type="text" name="zipcode" data-ng-model="myModel.zipcode" data-zipcode-alpha-numeric-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var zipcodeAlphaNumericValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[-a-zA-Z0-9 ]*$/;

            ctrl.$validators.zipcodeAlphaNumeric = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("zipcodeAlphaNumericValidator", zipcodeAlphaNumericValidator);

/**************** Directives for Account Setup - Email, Phone Number, Username, Password, Confirm/ Re-enter Password ************************/

/***** Email Validator ***********/

/**
 * Extends the AngularJS $validators to validate email address.
 *
 * Usage:
 * <input type="email" name="email" data-ng-model="myModel.email" data-email-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var emailValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern =
                /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@([a-zA-Z0-9\-'`]+[.])+[a-zA-Z]{2,}$/;

            ctrl.$validators.emailFormat = function (value) {
                return value === "" || value === null || value.length === 0
                    ? true
                    : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("emailValidator", emailValidator);

/***** Phone Number Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a ten-digit
 * Phone Number with no punctuation.
 *
 * Usage:
 * <input type="text" name="phoneNumber" data-ng-model="myModel.phoneNumber" data-phone-number-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */

var phoneNumberValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^\d{10}$/;

            ctrl.$validators.phoneNumberDigits = function (value) {
                if (value !== "" && value != "(___) ___-____") return pattern.test(value);
                else {
                    return true;
                }
            };
        }
    };
};
validationDirectives.directive("phoneNumberValidator", phoneNumberValidator);

/***** Phone Number Numeric Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for phone number
 * to be a numeric only entry.
 *
 * Usage:
 * <input type="tel" name="phoneNumber" data-ng-model="myModel.phoneNumber" data-phone-number-numeric-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var phoneNumberNumericValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[0-9]*$/;

            ctrl.$validators.phoneNumberNumeric = function (value) {
                return value === "" && value === "(___) ___-____" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("phoneNumberNumericValidator", phoneNumberNumericValidator);

var phoneNumberOnlyValidator = function () {
    return {
        require: "ngModel",
        link: function (scope, element, attr, ngModelCtrl) {
            function fromUser(text) {
                if (text != null && text != "") {
                    var transformedInput = text.replace(/[^0-9]/g, "");
                    if (transformedInput !== text) {
                        ngModelCtrl.$setViewValue(transformedInput);
                        ngModelCtrl.$render();
                    }
                    return transformedInput;
                } else {
                    return true;
                }
            }
            ngModelCtrl.$parsers.push(fromUser);
        }
    };
};
validationDirectives.directive("phoneNumberOnly", phoneNumberOnlyValidator);

/***** Username Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a username that must be at least
 * 6 characters long and may not be more than 63 characters. It must also be alphanumeric and have
 * at least one number and one letter.
 *
 * Usage:
 * <input type="text" name="username" data-ng-model="myModel.username" data-username-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var usernameValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var noSpacePattern = /^\S*$/;
            var minLengthPattern = /^[\s\S]{6,}$/;
            var maxLengthPattern = /^[\s\S]{0,63}$/;
            var usernameNumberPattern = /\d{1}/;
            var letterPattern = /(.*[A-Za-z]){3}/i;
            var allowedSpecialCharactersPattern = /^[@_.A-Za-z0-9-]+$/;

            ctrl.$validators.usernameNoSpace = function (value) {
                return noSpacePattern.test(value);
            };

            ctrl.$validators.minLength = function (value) {
                return minLengthPattern.test(value);
            };

            ctrl.$validators.usernameNumberPattern = function (value) {
                return usernameNumberPattern.test(value);
            };

            ctrl.$validators.letterPattern = function (value) {
                return letterPattern.test(value);
            };

            ctrl.$validators.allowedSpecialCharactersPattern = function (value) {
                if (value.length > 0) {
                    return allowedSpecialCharactersPattern.test(value);
                } else {
                    return true;
                }
            };

            /*
             ******************************************
              commented out for DEFC-17319
            *******************************************
            //
            // Set 'empty' class on the 'form-group' container when the field is cleared
            elem.on('keyup', function(e) {
                if (e.which !== 9 && e.which !== 0) { // only do when NOT enter or tab key
                    if ( ctrl.$viewValue === '' ) {
                        elem.parent().addClass('empty');
                    }
                    else {
                        elem.parent().removeClass('empty');
                    }
                }
            });
            */
        }
    };
};
validationDirectives.directive("usernameValidator", usernameValidator);

/***** Password Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a password that must be
 * At least 8 characters long
 * And include at least 3 from the 4 set of rules below:
 * 1) At least one number
 * 2) At least one lowercase letter
 * 3) At least one uppercase letter
 * 4) At least one special character *
 *
 * Usage:
 * <input type="text" name="password" data-ng-model="myModel.password" data-password-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var passwordValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl, form) {
            var minLengthPattern = /^[\s\S]{8,}$/;
            var maxLengthPattern = /^[\s\S]{0,63}$/;
            var numberPattern = /\d{1}/;
            var lowercasePattern = /^(?=.*[a-z]){1}/;
            var uppercasePattern = /^(?=.*[A-Z]){1}/;
            var specialCharPattern = /^(?=.*[=$@$!#%*?&+#._-]){1}/;

            ctrl.$validators.minLength = function (value) {
                return minLengthPattern.test(value);
            };

            ctrl.$validators.maxLength = function (value) {
                return maxLengthPattern.test(value);
            };

            ctrl.$validators.numberPattern = function (value) {
                var count = validationCount(value);
                if (count >= 3) {
                    return true;
                } else {
                    return numberPattern.test(value);
                }
            };

            ctrl.$validators.lowercasePattern = function (value) {
                var count = validationCount(value);
                if (count >= 3) {
                    return true;
                } else {
                    return lowercasePattern.test(value);
                }
            };

            ctrl.$validators.uppercasePattern = function (value) {
                var count = validationCount(value);
                if (count >= 3) {
                    return true;
                } else {
                    return uppercasePattern.test(value);
                }
            };

            ctrl.$validators.specialCharPattern = function (value) {
                var count = validationCount(value);
                if (count >= 3) {
                    return true;
                } else {
                    return specialCharPattern.test(value);
                }
            };

            ctrl.$validators.meetCondition0 = function (value) {
                var count = validationCount(value);
                if (count === 0) {
                    return false;
                } else {
                    return true;
                }
            };

            ctrl.$validators.meetCondition1 = function (value) {
                var count = validationCount(value);
                if (count === 1) {
                    return false;
                } else {
                    return true;
                }
            };

            ctrl.$validators.meetCondition2 = function (value) {
                var count = validationCount(value);
                if (count === 2) {
                    return false;
                } else {
                    return true;
                }
            };

            //
            // Set 'empty' class on the 'form-group' container when the field is cleared
            elem.on("keyup", function (e) {
                if (e.which !== 9 && e.which !== 0) {
                    if (ctrl.$viewValue === "") {
                        elem.parent().addClass("empty");
                    } else {
                        elem.parent().removeClass("empty");
                    }
                }
            });
        }
    };
};

var validationCount = function (value) {
    var numberPattern = /\d{1}/;
    var lowercasePattern = /^(?=.*[a-z]){1}/;
    var uppercasePattern = /^(?=.*[A-Z]){1}/;
    var specialCharPattern = /^(?=.*[=$@$!#%*?&+#._-]){1}/;

    var counter = 0;
    if (lowercasePattern.test(value)) {
        counter++;
    }
    if (uppercasePattern.test(value)) {
        counter++;
    }
    if (numberPattern.test(value)) {
        counter++;
    }
    if (specialCharPattern.test(value)) {
        counter++;
    }

    return counter;
};

validationDirectives.directive("passwordValidator", passwordValidator);

/***** Confirm/ Re-enter Password Validator***********/

/**
 * Confirm a user's password
 */
var compareTo = function () {
    return {
        // element must have ng-model attribute.
        require: "ngModel",

        scope: {
            otherModelValue: "=compareTo"
        },
        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        link: function (scope, element, attr, ngModel) {
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue == scope.otherModelValue;
            };

            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }
    };
};
validationDirectives.directive("compareTo", compareTo);

/***** Account Recovery screen ***********/

/**
 * Compare if Password matches username
 */
var compareToUsername = function () {
    return {
        // element must have ng-model attribute.
        require: "ngModel",

        scope: {
            otherModelValue: "=compareToUsername"
        },
        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        link: function (scope, element, attr, ngModel) {
            ngModel.$validators.compareToUsername = function (modelValue) {
                var modelValueUpperCase = modelValue ? modelValue.toUpperCase() : "";
                var otherModelValueUpperCase = scope.otherModelValue
                    ? scope.otherModelValue.toUpperCase()
                    : "";
                return modelValueUpperCase != otherModelValueUpperCase;
            };

            scope.$watch("otherModelValue", function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    ngModel.$validate();
                }
            });
        }
    };
};
validationDirectives.directive("compareToUsername", compareToUsername);

/**
 * Compare if the model value matches the targetValue and return false if the values are equal
 */
var cannotMatch = function () {
    return {
        // element must have ng-model attribute.
        require: "ngModel",

        scope: {
            targetValue: "=cannotMatch"
        },
        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        link: function (scope, element, attr, ngModel) {
            ngModel.$validators.cannotMatch = function (modelValue) {
                return modelValue.toUpperCase() !== scope.targetValue.toUpperCase();
            };

            scope.$watch("targetValue", function (newVal, oldVal) {
                if (newVal && newVal !== oldVal) {
                    ngModel.$validate();
                }
            });
        }
    };
};
validationDirectives.directive("cannotMatch", cannotMatch);

/**************** Directives for Registration With  Pin************************/

/***** PIN Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a 4-digit
 * PIN Number with no punctuation.
 *
 * Usage:
 * <input type="text" name="pin" data-ng-model="myModel.pin" data-pin-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var pinValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[0-9]*$/;
            ctrl.$validators.pinDigits = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("pinValidator", pinValidator);

/***** PIN Length Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a four-digit
 * PIN with no punctuation.
 *
 * Usage:
 * <input type="text" name="pin" data-ng-model="individual.pin" data-pin-length-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var pinLengthValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[\S]{4,64}$/;

            ctrl.$validators.pinLength = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("pinLengthValidator", pinLengthValidator);

/***** First Name Length Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for First Name

 *
 * Usage:
 * <input type="text" name="firstName" data-ng-model="ipersonalInfo.firstName" data-first-name-length-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var firstNameLengthValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[\S]{1,20}$/;

            ctrl.$validators.firstNameLength = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("firstNameLengthValidator", firstNameLengthValidator);

/***** Name Pattern Validator***********/

var namePatternValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[a-zA-Z' ]+$/;

            ctrl.$validators.namePattern = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("namePatternValidator", namePatternValidator);

/***** Last Name Length Validator***********/

var lastNameLengthValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^[\S]{1,35}$/;

            ctrl.$validators.lastNameLength = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("lastNameLengthValidator", lastNameLengthValidator);

/**************** Directives for Validation of Activation Code************************/

/***** Activation Code Validator***********/

/**
 * Extends the AngularJS $validators to validate an input field for a 8-digit
 * Activation Code with no punctuation.
 *
 * Usage:
 * <input type="text" name="verificationCode" data-ng-model="myModel.verificationCode" data-pin-validator />
 *
 * Note that we add the data- prefix to ensure valid HTML.
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var activationcodeValidator = function () {
    return {
        // restrict to an attribute type.
        restrict: "A",

        // element must have ng-model attribute.
        require: "ngModel",

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function (scope, elem, attr, ctrl) {
            var pattern = /^\d{8}$/;

            ctrl.$validators.activationcodeEightDigits = function (value) {
                return value === "" ? true : pattern.test(value);
            };
        }
    };
};
validationDirectives.directive("activationcodeValidator", activationcodeValidator);

export default validationDirectives;
